import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	messageContainer: {
		flex: 1
	},
	iconContainer: {
		width: 80
	},
	actionText: {
		cursor: "pointer",
		color: colors.yellow[500]
	},
	icon: {
		width: 40,
		height: 40,
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		borderRadius: 20
	},
	statusDescriptionText: {
		color: colors.gray[0],
		fontSize: 14,
		lineHeight: "20px"
	},
	slownessNotificationContainer: {
		padding: theme.spacing(2, 2, 2, 0),
		...ColorUtil.getBackgroundAndContrastColor(colors.yellow[50]),
		"& svg": {
			color: colors.yellow[500]
		}
	},
	slownessNotificationContent: {
		color: colors.gray[950],
		fontSize: 14,
		lineHeight: "20px"
	}
}))

export default useStyles
